import React from 'react';
import { Helmet } from 'react-helmet';
import Contact from '../../Components/Contact/Contact';
import Footer from '../../Components/Footer/Footer';
import Header from '../../Components/Header/Header';

import './page.scss'

const Page = ({children, title}) => {
    return (
        <div className="page">
            <Helmet>
                <meta charSet="utf-8" />
                <title>NokibRokes | Full-stack web developer | {title}</title>
                <link rel="canonical" href={`https://nokibrokes.com/${title}`} />
            </Helmet>
            <Header></Header>
            <h1 className="text-overlay">{title}</h1>

            {children}
            
            <Contact></Contact>
            <Footer/>
        </div>
    );
};

export default Page;